import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";
import { Location } from "./location";

@JsonConverter
export class DeviceConverter implements JsonCustomConvert<Device>{
	serialize() { }
	deserialize(data: any): Device {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, Device);
	}
}

@JsonConverter
export class DeviceArrayConverter implements JsonCustomConvert<Array<Device>>{
	serialize() { }
	deserialize(data: any): Array<Device> {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeArray(data, Device);
	}
}

@JsonConverter
export class DeviceListConverter implements JsonCustomConvert<DeviceList>{
	serialize() { }
	deserialize(data: any): DeviceList {
		const jsonConvert: JsonConvert = new JsonConvert();
		return jsonConvert.deserializeObject(data, DeviceList);
	}
}

@JsonObject("Device")
export class Device {
	@JsonProperty("uuid", String, true)
	uuid: string = "";
	@JsonProperty("mac", String, true)
	mac: string = "";
	@JsonProperty("name", String, true)
	name: string = "";
	@JsonProperty("nasid", String, true)
	nasid?: string = "";
	@JsonProperty("position", String, true)
	position?: string = "";
	@JsonProperty("enabled", Boolean, true)
	enabled: boolean = true;

	_location: string | undefined = "";

	setLocation(locations: Array<Location>) {
		this._location = locations.find(l => l.nasid === this.nasid) ? locations.find(l => l.nasid === this.nasid)?.name : this.nasid || "";
	}

	dto() {
		return {
			mac: this.mac,
			name: this.name,
			nasid: this.nasid,
			position: this.position,
			enabled: this.enabled
		}
	}

	dtoBulk() {
		return {
			mac: this.mac,
			name: this.name,
			nasid: this.nasid,
			position: this.position
		}
	}
}

@JsonObject("DeviceList")
export class DeviceList {
	@JsonProperty("count", Number, true)
	count: number = 0;
	@JsonProperty("data", DeviceArrayConverter, true)
	data: Array<Device> = new Array<Device>();

	setLocations(locations: Array<Location>) {
		this.data.forEach(d => {
			d.setLocation(locations);
		});
	}
}

@JsonObject("DeviceData")
export class DeviceData extends BaseResponse {
	@JsonProperty("data", DeviceConverter, true)
	data: Device = new Device();
}

@JsonObject("DeviceListData")
export class DeviceListData extends BaseResponse {
	@JsonProperty("data", DeviceListConverter, true)
	data: DeviceList = new DeviceList();
}

@JsonObject("DeviceListDataAll")
export class DeviceListDataAll extends BaseResponse {
	@JsonProperty("data", DeviceArrayConverter, true)
	data: Array<Device> = new Array<Device>();
}